import { authFetch } from "~/services/fetch";

export async function getAllTypesInterestPoint(): Promise<readonly any[]> {
    const response = await authFetch({
        url: '/interest-point/type/',
        method: 'GET'
    });
    return response.data;
}